import {createAsyncThunk} from '@reduxjs/toolkit'
import {speaker} from "../../api/speaker";

const fetchList = createAsyncThunk('speakers/getList', async (id) => {
  try {
    const speakers = await speaker.methods.getList();
    return speakers
  } catch (e) {
    console.error("fetchSpeakerList error: ", e);
    throw e;
  }
})


export const SpeakersActions = {
  fetchList
}
